/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;flex:1}.header-title[_ngcontent-%COMP%]{font-size:16px;font-weight:400;font-style:normal;color:#000}.header-title[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:400}.display-text[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
